import { connect } from 'react-redux'
import ProviderProductList from '../../components/products/ProviderProductList'
import { fetchProductsByOrganizationId, actionCreators } from '../../state/actions/provider-products'
import { IProviderProductFilters, IProviderProductObject, IStoreState } from '../../types'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const products = state.providerProduct.items ? Object.values(state.providerProduct.items) : []
  return {
    organizationId: state.organizations.currentOrgId,
    products,
    type: ownProps.type,
    query: state.providerProduct.query,
    filters: state.providerProduct.filters,
    isDeactive: state.providerProduct.deactivateProductModal.show,
    isActive: state.providerProduct.activateProductModal.show,
    productCount: state.providerProduct.productCount
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onComponentMount: (dto: IProviderProductFilters) => {
      dispatch(fetchProductsByOrganizationId(dto))
    },
    showDeleteDialog: (product: IProviderProductObject) => {
      dispatch(actionCreators.productDeleteModalShow(product))
    },
    showActivateDialog: (product: IProviderProductObject) => {
      dispatch(actionCreators.productActivateModalShow(product))
    },
    showDeactivateDialog: (product: IProviderProductObject) => {
      dispatch(actionCreators.productDeactivateModalShow(product))
    },
    updateProductFilters: (params: IProviderProductFilters) => {
      return dispatch(actionCreators.updateProductFilters(params))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderProductList)



// WEBPACK FOOTER //
// ./src/containers/products/ProviderProductList.ts